export default "__VITE_ASSET__DQ4rBDgf__"